<div class="frm">
    <div class="row">
        <div *ngIf="brandNew" class="alert alert-success" role="alert">
            <strong>All set!</strong> Please login with your account
        </div>
        <h2 style="text-align: center">Login</h2>
        <div style="text-align: center; margin-top:-25px; margin-bottom:25px;">
            Keep your route list on the cloud and see it from anywhere
        </div>
    </div>

     <form #f="ngForm" novalidate (ngSubmit)="login(f)">

        <div class="row frm2" style="background-color:#f4f4f4">
            <div class="col-md-6">

                <div class="form-group">
                    <label for="email">Email</label>
                    <input id="email" type="text" required email name="email" class="form-control" placeholder="Email" [ngModel]="credentials.email" #email="ngModel">
                    <small [hidden]="email.valid || (email.pristine && !submitted)" class="text-danger">Please enter a valid email</small>
                </div>
                <div class="form-group">
                    <label for="password">Password</label>
                    <input type="password" class="form-control" id="password" required name="password" placeholder="Password" ngModel>
                </div>

            </div>
        </div>

        <div class="row" dir="rtl">
            <div class="col-md-6">
                <div class="form-group btnSave">
                    <button type="submit" class="btn btn-primary" [disabled]="f.invalid || isRequesting" style="background-color:blue">Login</button>
                    <app-spinner [isRunning]="isRequesting"></app-spinner>
                </div>

                <div *ngIf="errors" class="alert alert-danger" role="alert">
                    <strong>Oops!</strong> {{errors}}
                </div>
            </div>
        </div>


    </form> 
</div>